<app-navbar></app-navbar>

<div class="container-fluid course-page">
  <div class="row">
    <nav class="col-md-3 col-lg-2 d-md-block sidebar course-sidebar">
      <div class="sidebar-sticky">
        <ul class="nav flex-column">
          <li class="nav-item">
            <a class="nav-link" routerLink="/electric-cars">
              <i class="fa fa-book" aria-hidden="true"></i>
              <span>Electric Cars</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/design-and-manufacturing">
              <i class="fa fa-book" aria-hidden="true"></i>
              <span>Design and Manufacturing</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/auto-electrical">
              <i class="fa fa-book" aria-hidden="true"></i>
              <span>Auto Electrical of an Electric Scooter</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/iot">
              <i class="fa fa-book" aria-hidden="true"></i>
              <span>Internet of Things</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/charger-installation">
              <i class="fa fa-book" aria-hidden="true"></i>
              <span>Charger Installation</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/solar-installation">
              <i class="fa fa-book" aria-hidden="true"></i>
              <span>Solar Installation</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/welding">
              <i class="fa fa-book" aria-hidden="true"></i>
              <span>Welding</span>
            </a>
          </li>
        </ul>
      </div>
    </nav>

    <main role="main" class="col-md-9 col-lg-10 ms-sm-auto px-3 px-md-4 py-4 course-content">
      <section class="course-header">
        <p class="course-tag">FEA Course</p>
        <h1>Female Engineers Academy - Workshop Tools and Safety Precautions</h1>
        <p class="course-subtitle">Learn through guided lessons and complete the module resources and progress checkpoints.</p>
      </section>

      <section class="lesson-grid">
        <article class="lesson-card">
          <h4><span>01</span> Lesson 01</h4>
          <video controls controlsList="nodownload">
            <source src="https://firebasestorage.googleapis.com/v0/b/solar-academy-18d4c.appspot.com/o/videos%2FIntroduction-to-workshop-tools-and-safety%2FIntroduction%20to%20Workshop%20Safety_Prt.%201.mp4?alt=media&token=671280ac-13e5-4d5c-9436-6d41a89de88f" type="video/mp4">
          </video>
        </article>

        <article class="lesson-card">
          <h4><span>02</span> Lesson 02</h4>
          <video controls controlsList="nodownload">
            <source src="https://firebasestorage.googleapis.com/v0/b/solar-academy-18d4c.appspot.com/o/videos%2FIntroduction-to-workshop-tools-and-safety%2FIntroduction%20to%20Workshop%20Safety_Prt.%202.mp4?alt=media&token=2c2b15d7-4064-43d1-b6eb-58f86a9500ce" type="video/mp4">
          </video>
        </article>

        <article class="lesson-card">
          <h4><span>03</span> Lesson 03</h4>
          <video controls controlsList="nodownload">
            <source src="https://firebasestorage.googleapis.com/v0/b/solar-academy-18d4c.appspot.com/o/videos%2FIntroduction-to-workshop-tools-and-safety%2FIntroduction%20to%20Workshop%20Safety_Prt.%203.mp4?alt=media&token=e235fea1-fcbb-4384-9ddc-8218f70ae94d" type="video/mp4">
          </video>
        </article>

      </section>

      <section class="course-actions">
        <a class="btn solarorange" href="https://firebasestorage.googleapis.com/v0/b/solar-academy-18d4c.appspot.com/o/course-slides%2FIntroduction%20to%20workshop%20safety.pdf?alt=media&token=06be4187-ca84-4d1d-a4b6-d3d969faf6f3" target="_blank" rel="noopener noreferrer">
          Download Course Material
        </a>

        <button type="button" class="btn solarorange complete-btn" (click)="completed()">
          Mark Completed
        </button>
      </section>
    </main>
  </div>
</div>
